import { createComponent, ComponentProps } from '@/internals/utils';
export type TagGroupProps = ComponentProps;

/**
 * The `TagGroup` component for use with the `Tag` component.
 *
 * @see https://rsuitejs.com/components/tag/
 */
const TagGroup = createComponent({ name: 'TagGroup' });

export default TagGroup;
